import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumsHeader from "../BreadCrums";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Status from "../Status";
import Delete from "../Delete";
import Edit from "../Edit";
import Pagination from "../TablePagination";
import CreateNewButton from "../CreateNewButton";
import { ReactComponent as Image } from "../../../Assets/Icons/Image.svg";
import { ReactComponent as LocationIcon } from "../../../Assets/Icons/Location.svg";
import { ReactComponent as ApprovedSubCategoryIcon } from "../../../Assets/Icons/approvedsubCategoryIcon.svg";
import { ReactComponent as SubCategoryIcon } from "../../../Assets/Icons/subCategoryIcon.svg";
import { ReactComponent as UnapprovedSubCatIcon } from "../../../Assets/Icons/unapprovedSubCatIcon.svg";
import { ReactComponent as ApprovedRulesIcon } from "../../../Assets/Icons/approvedRulesIcon.svg";
import { ReactComponent as RulesIcon } from "../../../Assets/Icons/rulesIcon.svg";
import { ReactComponent as UnapprovedRulesIcon } from "../../../Assets/Icons/unapprovedRulesIcon.svg";
import descriptionIcon from "../../../Assets/Icons/descriptionIcon.svg";
import {
  deleteOffer,
  getOfferById,
  getOffersByMerchant,
  toggleOfferStatus,
} from "../../../services/offerService";
import ImagePopup from "../ImagePopup";
import LocationPopup from "../LocationPopup";
import CancelPopup from "../CancelPopup";
import deleteImg from "../../../Assets/Images/deleteImg.svg";
import { separateDateTimeAndConvertToLocale } from "../../../utils/utilFunctions";
import Loader from "../../common/Loader";
import DetailsPopup from "../DetailsPopup";
import SubCategoryPopup from "../SubCategoryPopup";
import Confirmation from "./Confirmation";
import infoIcon from "../../../Assets/Icons/infoIcon.svg";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import { ReactComponent as FiltersIcon } from "../../../Assets/Icons/filtersIcon.svg";
import SearchBar from "../SearchBar";
import debounce from "lodash.debounce";
import { Dropdown } from "antd";
import FilterPanel from "../FilterPanel";
import { getCategories } from "../../../services/offerService";
import DetailsModal from "../DetailsModal";
import PopupContent from "./PopupContent";
import ViewCodesModal from "./ViewCodesModal";
import AddCodesModal from "./AddCodesModal";

import { DatePicker } from "antd";
import FilterButton from "../../common/FilterButton";

const MerchantOfferlist = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const selectedMerchant = useSelector((state) => state?.merchantReducer.selectedMerchent);
  const loading = useSelector((state) => state?.offerReducer?.loading);
  const [allOffers, setAllOffers] = useState();
  const [hasFetchedOffers, setHasFetchedOffers] = useState(false);
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [isLocationOpen, setIsLocationOpen] = useState(false);
  const [deleteClicked, setDeleteClicked] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [isSubCategoryOpen, setIsSubCategoryOpen] = useState(false);
  const [isRulesOpen, setIsRulesOpen] = useState(false);
  const [clickedOffer, setClickedOffer] = useState(null);
  const [infoClicked, setInfoClicked] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [offerToDelete, setOfferToDelete] = useState(null);
  const [categories, setCategories] = useState([]);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [offerDetails, setOfferDetails] = useState(null);
  const [customDate, setCustomDate] = useState([null, null]);
  const [isViewCodesModalOpen, setIsViewCodesModalOpen] = useState(false);
  const [isAddCodesModalOpen, setIsAddCodesModalOpen] = useState(false);
  const [selectedOfferForCodes, setSelectedOfferForCodes] = useState(null);

  const [filterParams, setFilterParams] = useState({
    category: null,
    subCategory: [], // Initialize as empty array for multi-select
    status: null,
    duration: null,
    offerType: null,
    redemptionMethod: null,
  });

  useEffect(() => {
    console.log("Component mounted, getting categories data");
    getCategoriesData();
  }, []);
  // Add these mappings
  const DURATION_MAP = {
    "Today": "DAY",
    "This Week": "WEEK",
    "This Month": "MONTH",
    "This Year": "YEAR",
    "Custom Date": "CUSTOM",
  };

  const STATUS_MAP = {
    "Approved": "approved", // Matches your enum directly
    "Declined": "declined", // Matches your enum directly
    "Pending": "pending",   // Matches your enum directly
    "Drafted": "drafted",
  };

  const OFFER_TYPE_MAP = {
    "Instore Swoodle Offer": "INSTORE_SWOODLE_OFFER", // Corrected as per your API
    "Online": "ONLINE_OFFER", // Corrected as per your API
  };

  const REDEMPTION_METHOD_MAP = {
    "Swoodle Code Offer": "SWOODLE_CODE_OFFER", // Based on common redemption types matching your API's IN_STORE
    "QR Code Offer": "QR_CODE",     // Assuming QR/Bar Code are in-store methods
    "Bar Code Offer": "BAR_CODE",    // Assuming QR/Bar Code are in-store methods
  };
  const [filterData, setFilterData] = useState([
    {
      id: "duration",
      title: "Duration",
      options: ["Today", "This Week", "This Month", "This Year", "Custom Date"],
      defaultValue: "Today",
      multiSelect: false,
      valueMap: DURATION_MAP, // Add this
      customContent: (selected) => {
        return selected === "Custom Date" ? (
          <div className="mt-3 flex flex-col gap-2">
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">Start Date</label>
              <DatePicker
                value={customDate?.[0]}
                onChange={(date) => {
                  const newDates = [date, customDate?.[1]];
                  setCustomDate(newDates);
                }}
                style={{ width: '100%' }}
                placeholder="Start Date"
                format="YYYY-MM-DD"
              />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[12px] font-medium text-gray-600">End Date</label>
              <DatePicker
                value={customDate?.[1]}
                onChange={(date) => {
                  const newDates = [customDate?.[0], date];
                  setCustomDate(newDates);
                }}
                style={{ width: '100%' }}
                placeholder="End Date"
                format="YYYY-MM-DD"
              />
            </div>
          </div>
        ) : null;
      }
    },
    {
      id: "status",
      title: "Status",
      options: ["Approved", "Declined", "Pending", "Drafted"], // Ensure these match your API's lowercase enum, but display as capitalized
      // defaultValue: "Approved",
      multiSelect: false,
      valueMap: STATUS_MAP, // Add this
    },
    {
      id: "category",
      title: "Category",
      options: [], // Will be populated from API
      defaultValue: "",
      multiSelect: false,
      optionValueKey: "_id",
      optionLabelKey: "title",
    },
    {
      id: "subcategory",
      title: "Subcategory",
      options: [], // Will be populated based on selected category
      defaultValue: [],
      multiSelect: true, // Allow multiple subcategory selection
      optionValueKey: "_id",
      optionLabelKey: "title",
    },
    {
      id: "offerType",
      title: "Offer Type",
      options: ["Instore Swoodle Offer", "Online"],
      // defaultValue: "Instore Swoodle Offer",
      multiSelect: false,
      valueMap: OFFER_TYPE_MAP, // Add this
    },
    {
      id: "redemptionMethod",
      title: "Redemption Method",
      options: ["Swoodle Code Offer", "QR Code Offer", "Bar Code Offer"], // Re-evaluate these for mapping to IN_STORE, ONLINE, BOTH
      // defaultValue: "Swoodle Code Offer",
      multiSelect: false,
      valueMap: REDEMPTION_METHOD_MAP, // Add this
    },
  ]);

  // Create initial state from filter data
  const createInitialState = (filters) => {
    return filters.reduce((acc, filter) => {
      if (filter.multiSelect) {
        // For multi-select, initialize as array
        acc[filter.id] = Array.isArray(filter.defaultValue)
          ? filter.defaultValue
          : [];
      } else {
        // For single select, initialize as single value
        acc[filter.id] = filter.defaultValue;
      }
      return acc;
    }, {});
  };

  // Initialize selections with the initial state
  const [selections, setSelections] = useState({
    duration: "Today",
    status: null,
    category: null,
    subcategory: [],
    offerType: null,
    redemptionMethod: null,
  });

  // Update the getCategoriesData function to populate filterData
  const getCategoriesData = async () => {
    const categoryPromise = await dispatch(getCategories())?.unwrap();
    if (categoryPromise?.success === true) {
      const categoriesData = categoryPromise?.data;
      setCategories(categoriesData);

      // Update the category filter with data from API
      setFilterData((prevFilters) => {
        const newFilters = prevFilters.map((filter) => {
          if (filter.id === "category") {
            console.log("Updating category filter with options:", categoriesData);
            return {
              ...filter,
              options: categoriesData,
              // defaultValue:
              //   categoriesData.length > 0 ? categoriesData[0]._id : "",
            };
          }
          return filter;
        });
        console.log("Updated filterData in getCategoriesData:", newFilters);
        return newFilters;
      });

      // Update selections with the first category as default if available
      if (categoriesData.length > 0) {
        // Also update subcategories based on the first category
        updateSubcategoriesForCategory(categoriesData[0]);
      }
    }
  };

  // Helper function to filter approved subcategories
  const getApprovedSubcategories = (category) => {
    if (
      !category ||
      !category.subCategory ||
      !Array.isArray(category.subCategory)
    ) {
      return [];
    }

    return category.subCategory;
  };

  // Helper function to update subcategories when a category is selected
  const updateSubcategoriesForCategory = (selectedCategory) => {
    if (!selectedCategory) return;

    console.log("updateSubcategoriesForCategory called with:", selectedCategory);

    // Get approved subcategories
    const approvedSubcategories = getApprovedSubcategories(selectedCategory);
    console.log("Approved subcategories:", approvedSubcategories);

    // Update the subcategory filter
    setFilterData((prevFilters) => {
      const newFilters = prevFilters.map((filter) => {
        if (filter.id === "subcategory") {
          console.log("Updating subcategory filter with options:", approvedSubcategories);
          return {
            ...filter,
            options: approvedSubcategories,
            defaultValue: [],
          };
        }
        return filter;
      });
      console.log("Updated filterData:", newFilters);
      return newFilters;
    });

    // Reset subcategory selections
    setSelections((prev) => {
      const newSelections = {
        ...prev,
        subcategory: [], // Initialize as empty array for multi-select
      };
      console.log("Reset subcategory selections:", newSelections);
      return newSelections;
    });
  };

  // Use effect to initialize subcategories when categories are loaded
  useEffect(() => {
    console.log("useEffect for categories/selections.category:", { categories: categories.length, selectionsCategory: selections.category });
    if (categories.length > 0 && selections.category) {
      const selectedCategory = categories.find(
        (cat) => cat._id === selections.category
      );
      if (selectedCategory) {
        console.log("Found category in useEffect, updating subcategories");
        updateSubcategoriesForCategory(selectedCategory);
      }
    }
  }, [categories, selections.category]);

  // Debug useEffect to log when selections change
  useEffect(() => {
    console.log("Selections changed:", selections);
  }, [selections]);

  // Debug useEffect to log when filterData changes
  useEffect(() => {
    console.log("FilterData changed:", filterData);
  }, [filterData]);

  // Update the handleSelectionChange function
  const handleSelectionChange = (filterId, value) => {
    console.log("handleSelectionChange called", filterId, value);

    setSelections((prev) => {
      const newSelections = {
        ...prev,
        [filterId]: value,
      };
      console.log("New selections:", newSelections);
      return newSelections;
    });

    // If category changes, update subcategories
    if (filterId === "category") {
      console.log("Category changed, updating subcategories for:", value);
      // Find the selected category
      const selectedCategory = categories.find((cat) => cat._id === value);
      if (selectedCategory) {
        console.log("Found selected category:", selectedCategory);
        updateSubcategoriesForCategory(selectedCategory);
      } else {
        console.log("Category not found in categories:", categories);
      }
    }
  };

  // Update the handleReset function
  const handleReset = () => {
    const resetSelections = {
      duration: "Today",
      status: null,
      category: null,
      subcategory: [],
      offerType: null,
      redemptionMethod: null,
    };
    setSelections(resetSelections);

    // If we have categories, reset subcategories for the first category
    if (categories.length > 0) {
      updateSubcategoriesForCategory(categories[0]);
    }

    // Reset filter params to trigger new API call
    setFilterParams({
      category: null,
      subCategory: [],
      status: null,
      duration: null,
      offerType: null,
      redemptionMethod: null,
    });
  };

  // When applying filters, you can now access both category ID and subcategory IDs array
  const handleApply = () => {
    console.log("Applying filters - selections:", selections);
    console.log("Applying filters - filterData:", filterData);

    // Create a new object for mapped filter parameters
    const mappedFilterParams = {};

    filterData.forEach(filter => {
      const selectedValue = selections[filter.id];
      console.log(`Processing filter ${filter.id}:`, { selectedValue, filter });

      if (selectedValue !== null && selectedValue !== undefined && selectedValue !== '' && !(Array.isArray(selectedValue) && selectedValue.length === 0)) {
        if (filter.id === "category") {
          mappedFilterParams.category = selectedValue; // Category ID is already correct
          console.log("Added category to mapped params:", selectedValue);
        } else if (filter.id === "subcategory") {
          mappedFilterParams.subCategory = selectedValue; // Subcategory IDs array is correct
          console.log("Added subCategory to mapped params:", selectedValue);
        } else if (filter.valueMap) {
          // Use the value map for other filters
          mappedFilterParams[filter.id] = filter.multiSelect
            ? selectedValue.map(val => filter.valueMap[val]) // For multi-select, map each value
            : filter.valueMap[selectedValue]; // For single select, map the value
          console.log(`Added ${filter.id} to mapped params:`, mappedFilterParams[filter.id]);
        } else {
          mappedFilterParams[filter.id] = selectedValue;
          console.log(`Added ${filter.id} to mapped params:`, selectedValue);
        }
      } else {
        console.log(`Skipping filter ${filter.id} - value is empty/null/undefined`);
      }
    });

    console.log("Final Mapped Filter Params:", mappedFilterParams);
    setFilterParams(mappedFilterParams);
    setOpen(false);
  };

  // Handle cancel button click
  const handleCancel = () => {
    setOpen(false);
  };

  const handleOpenChange = (flag) => {
    setOpen(flag);
  };

  useEffect(() => {
    if (open) {
      document.body.classList.add("dropdown-open");
    } else {
      document.body.classList.remove("dropdown-open");
    }

    return () => {
      document.body.classList.remove("dropdown-open");
    };
  }, [open]);

  const items = [
    {
      title: "Offers",
    },
    {
      title: "Offers List",
    },
  ];

  const columns = [
    {
      name: "No.",
    },
    {
      name: "Title",
    },
    {
      name: "Category Type",
    },
    {
      name: "Offer Type",
    },
    {
      name: "Discount Type",
    },
    {
      name: "Status",
    },
    {
      name: "Actions",
    },
  ];

  const getOffersData = async () => {
    console.log("filterParams:", filterParams);
    const params = {
      page: currentPage,
      // API expects 'search', not 'searchQuery'
      search: searchQuery || undefined, // Use undefined to ensure it's removed by Object.keys().forEach if null/empty

      // API expects 'category', not 'categoryId'
      category: filterParams.category || undefined,

      // API expects 'subCategory', not 'subCategoryId'.
      // Join array with comma if the API expects it as a comma-separated string.
      subCategory: filterParams.subCategory && filterParams.subCategory.length > 0
        ? filterParams.subCategory.join(',')
        : undefined,

      // Use the mapped values directly from filterParams
      offerType: filterParams.offerType || undefined,
      status: filterParams.status || undefined,
      duration: filterParams.duration || undefined,
      redemptionMethod: filterParams.redemptionMethod || undefined,

      limit: 10,
    };

    // Remove undefined values to avoid sending empty parameters
    Object.keys(params).forEach((key) =>
      params[key] === undefined ? delete params[key] : null // Use undefined for deletion logic
    );
    console.log("Fetching offers with params:", params);

    const offersPromise = await dispatch(getOffersByMerchant(params))?.unwrap();
    if (offersPromise?.success === true) {
      setAllOffers(offersPromise?.data);
      setCurrentPage(offersPromise?.currentPage);
      setTotalPages(offersPromise?.totalPages);
      setCount(offersPromise?.count);
      setHasFetchedOffers(true);
    } else {
      setHasFetchedOffers(false);
    }
  };

  // Keep this useEffect for fetching data
  useEffect(() => {
    console.log("filterParams changed, fetching data:", filterParams);
    getOffersData();
  }, [deleteSuccess, currentPage, filterParams, selectedMerchant]); // Removed searchQuery from dependencies

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleImageIconClick = (offer) => {
    setClickedOffer(offer);
    setIsImageOpen(true);
  };

  const handleCloseImage = () => {
    setIsImageOpen(false);
    setClickedOffer(null);
  };

  const handleLocationClick = (offer) => {
    setClickedOffer(offer);
    setIsLocationOpen(true);
  };

  const handleDescriptionClick = (offer) => {
    setClickedOffer(offer);
    setIsDescriptionOpen(true);
  };

  const handleSubCategoryClick = (offer) => {
    setClickedOffer(offer);
    setIsSubCategoryOpen(true);
  };

  const handleRulesClick = (offer) => {
    setClickedOffer(offer);
    setIsRulesOpen(true);
  };

  const handleCloseLocation = () => {
    setIsLocationOpen(false);
    setClickedOffer(null);
  };

  const handleCloseDescription = () => {
    setIsDescriptionOpen(false);
    setClickedOffer(null);
  };

  const handleCloseSubCategory = () => {
    setIsSubCategoryOpen(false);
    setClickedOffer(null);
  };

  const handleCloseRules = () => {
    setIsRulesOpen(false);
    setClickedOffer(null);
  };

  const handleEditClick = (id) => {
    navigate("/merchant/offer-form", {
      state: {
        id: id,
      },
    });
  };

  const handleDeleteClick = (offer) => {
    setDeleteClicked(true);
    setClickedOffer(offer);
  };

  const handleKeepOffer = () => {
    setDeleteClicked(false);
    setClickedOffer(null);
  };

  const handleDeleteOffer = async () => {
    // Close detail popup and the confirmation modal
    closePopup();
    setDeleteClicked(false);
    if (clickedOffer?._id !== null) {
      const deletePromise = await dispatch(
        deleteOffer({ id: clickedOffer?._id })
      )?.unwrap();
      if (deletePromise?.success === true) {
        setDeleteSuccess(!deleteSuccess);
        setClickedOffer(null);
      }
    }
  };

  // const handleToggle = async (id) => {
  //   try {
  //     const togglePromise = await dispatch(
  //       toggleOfferStatus({ id: id })
  //     ).unwrap();
  //     if (togglePromise?.success === true) {
  //       getOffersData();
  //     }
  //   } catch (error) {
  //     console.error("Error toggling location status:", error);
  //   }
  // };

  const handleCloseInfo = () => {
    setInfoClicked(false);
    setClickedOffer(null);
  };

  const handleInfoClick = (offer) => {
    setClickedOffer(offer);
    setInfoClicked(true);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((query) => {
        // Avoid sending server search while typing; fetch base list only
        getOffersData();
      }, 400),
    [filterParams]
  );

  const handleSearchChange = (value) => {
    setSearchQuery(value);
    debouncedSearch(value);
  };

  // Cleanup debounced search on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  // Client-side filtering to include title, category title, offer type, discount type
  const visibleOffers = useMemo(() => {
    if (!Array.isArray(allOffers) || (searchQuery || "").trim() === "") {
      return allOffers;
    }
    const q = (searchQuery || "").toLowerCase();
    const normalizeOfferType = (t) => {
      if (!t) return "";
      switch (t) {
        case "ONLINE_OFFER":
          return "online offer";
        case "INSTORE_SWOODLE_OFFER":
          return "instore swoodle offer";
        default:
          return String(t).toLowerCase();
      }
    };
    const normalizeDiscountType = (t) => {
      if (!t) return "";
      switch (t) {
        case "FREE_OFFER":
          return "free offer";
        case "DISCOUNTED_PERCENT":
          return "discounted percent";
        case "FIXED_DOLLAR":
          return "fixed dollar";
        case "BUY_ONE_GET_ONE_FREE":
          return "buy one get one free";
        case "BUNDLE_OFFER":
          return "bundle offer";
        default:
          return String(t).toLowerCase();
      }
    };
    return allOffers.filter((o) => {
      const title = (o?.title || "").toLowerCase();
      const category = (o?.category?.title || "").toLowerCase();
      const offerType = normalizeOfferType(o?.offerType);
      const discountType = normalizeDiscountType(o?.offerDiscountType);
      return (
        title.includes(q) ||
        category.includes(q) ||
        offerType.includes(q) ||
        discountType.includes(q)
      );
    });
  }, [allOffers, searchQuery]);

  const fetchOfferDetails = async (offerId) => {
    try {
      const offerDetailsPromise = await dispatch(getOfferById({ id: offerId, silent: true }))?.unwrap();
      if (offerDetailsPromise?.success === true) {
        setOfferDetails(offerDetailsPromise?.data);
      }
    } catch (error) {
      console.error("Error fetching offer details:", error);
    }
  };

  const openPopup = (offerId) => {
    setOfferDetails(null);
    setIsDetailOpen(true);
    fetchOfferDetails(offerId);
  };

  const closePopup = () => {
    setIsDetailOpen(false);
    // setPopupContent("");
  };

  // Open direct from navigation state (e.g., notifications deep-link)
  useEffect(() => {
    const stateOfferId = location?.state?.openOfferId || location?.state?.offerId;
    if (stateOfferId) {
      openPopup(stateOfferId);
      // Clear the navigation state so modal does not reopen on re-render
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location?.state?.openOfferId, location?.state?.offerId, location.pathname, navigate]);

  const handleOpenViewCodes = (offerDetails) => {
    setIsDetailOpen(false); // Close the parent modal
    setTimeout(() => {
      setSelectedOfferForCodes(offerDetails);
      setIsViewCodesModalOpen(true);
    }, 300); // Wait for modal close animation (if any)
  };

  const handleOpenAddCodes = (offerDetails) => {
    setIsDetailOpen(false); // Close the parent modal
    setTimeout(() => {
      setSelectedOfferForCodes(offerDetails);
      setIsAddCodesModalOpen(true);
    }, 300);
  };

  const handleCloseViewCodes = () => {
    setIsViewCodesModalOpen(false);
    setSelectedOfferForCodes(null);
    setIsDetailOpen(true); // Reopen the parent modal
  };

  const handleCloseAddCodes = () => {
    setIsAddCodesModalOpen(false);
    setSelectedOfferForCodes(null);
    setIsDetailOpen(true); // Reopen the parent modal
  };

  // Handler to go from ViewCodesModal to AddCodesModal
  const handleAddCodesFromView = () => {
    setIsViewCodesModalOpen(false);
    setIsAddCodesModalOpen(true);
  };

  // No status-change UI in merchant list; admin handles status updates

  console.log('offerDetails', offerDetails)

  return (
    <>
      {loading === true && <Loader />}
      {clickedOffer?.thumbnailImage !== null && isImageOpen === true && (
        <ImagePopup
          image={clickedOffer?.thumbnailImage}
          handleCloseImage={handleCloseImage}
        />
      )}
      {isLocationOpen === true && (
        <LocationPopup
          locations={clickedOffer?.tempLocations}
          handleCloseLocation={handleCloseLocation}
        />
      )}
      {clickedOffer?.description !== "" && isDescriptionOpen === true && (
        <DetailsPopup
          content={clickedOffer?.description}
          handleClose={handleCloseDescription}
          icon={descriptionIcon}
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
        />
      )}
      {clickedOffer?.subCategory?.length > 0 && isSubCategoryOpen === true && (
        <SubCategoryPopup
          subCategories={clickedOffer?.subCategory}
          handleCloseSubCategory={handleCloseSubCategory}
          icon={<SubCategoryIcon className="w-[10%]" />}
          heading="Subcategories"
        />
      )}
      {clickedOffer?.ruleAndRegulation?.length > 0 && isRulesOpen === true && (
        <SubCategoryPopup
          subCategories={clickedOffer?.ruleAndRegulation}
          handleCloseSubCategory={handleCloseRules}
          icon={<RulesIcon className="w-[10%]" />}
          heading="Rules and Regulations"
        />
      )}
      {isDetailOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" style={{ animation: 'fadeIn 0.25s cubic-bezier(0.16, 1, 0.3, 1)' }}>
          <style>
            {`
              @keyframes fadeIn {
                from { opacity: 0; }
                to { opacity: 1; }
              }
              @keyframes slideIn {
                from {
                  opacity: 0;
                  transform: scale(0.95) translateY(-20px);
                }
                to {
                  opacity: 1;
                  transform: scale(1) translateY(0);
                }
              }
            `}
          </style>
          <div style={{ animation: 'slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)' }}>
            <PopupContent
              offerDetails={offerDetails}
              handleDeleteClick={handleDeleteClick}
              handleEditClick={handleEditClick}
              onOpenViewCodes={handleOpenViewCodes}
              onOpenAddCodes={handleOpenAddCodes}
              onClose={closePopup}
              onDuplicated={getOffersData}
            />
          </div>
        </div>
      )}
      {isViewCodesModalOpen && (
        <ViewCodesModal
          onClose={handleCloseViewCodes}
          codes={Array(100).fill('FNPR5RG')}
          usedCount={1}
          totalCount={100}
          onAddCodes={handleAddCodesFromView}
        />
      )}
      {isAddCodesModalOpen && (
        <AddCodesModal onClose={handleCloseAddCodes} />
      )}
      <div className="flex justify-between col-span-12">
        <BreadCrumsHeader heading="Offers List" items={items} />
        <CreateNewButton
          text={"Create New Offer"}
          navigateTo={"/merchant/offer-form"}
          iconClassName="sm:left-[1%] md:left-[8%] bottom-[30%]"
        />
      </div>
      {deleteClicked === true ? (
        <CancelPopup
          handleNo={handleKeepOffer}
          handleYes={handleDeleteOffer}
          heading={"Delete Offer"}
          content={"Are you sure you want to delete this offer?"}
          image={deleteImg}
        />
      ) : null}
      {infoClicked === true && (
        <DetailsPopup
          content={clickedOffer?.reason}
          handleClose={handleCloseInfo}
          icon={infoIcon}
          popupClassName={"w-[335px] sm:w-[470px] pb-5"}
        />
      )}
      <div className="w-full flex justify-between items-center mt-4">
        <SearchBar
          parentDivClass="w-[65%] md:w-[40%] lg:w-[35%] xl:w-[30%]"
          divClassName="relative"
          inputClassName="searchBar w-full p-3 text-[14px] font-poppins font-[400] outline-none"
          iconClassName="absolute sm:right-[5%] sm:bottom-[25%] lg:right-[3%]"
          placeholder="Search"
          value={searchQuery}
          handleChange={(e) => handleSearchChange(e.target.value)}
        />
        <Dropdown
          overlay={
            <FilterPanel
              filterData={filterData}
              selections={selections}
              handleApply={handleApply}
              handleCancel={handleCancel}
              handleReset={handleReset}
              handleSelectionChange={handleSelectionChange}
            />
          }
          trigger={["click"]}
          open={open}
          onOpenChange={handleOpenChange}
          placement="bottomRight"
          overlayStyle={{
            minWidth: "320px",
            maxHeight: "80vh",
            zIndex: 1000,
          }}
          overlayClassName="filter-dropdown-overlay"
        >
          <FilterButton isOpen={open} />
        </Dropdown>
      </div>
      <div className="col-span-12 mt-4">
        <TableContainer style={{ width: "100%", overflowX: "auto" }}>
          <Table
            sx={{
              minWidth: "800px",
              borderCollapse: "separate",
              borderSpacing: "0px 8px",
            }}
            aria-label="simple table"
          >
            <TableHead className="bg-[#00ADEF]">
              <TableRow
                className="h-[50px]"
                sx={{ boxShadow: "0px 4px 4px 0px #00000040" }}
              >
                {columns.map((column) => {
                  return (
                    <TableCell key={column.name} className="!text-[#FFFFFF]">
                      {column.name}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {(hasFetchedOffers && !loading && (!Array.isArray(visibleOffers) || visibleOffers.length === 0)) && (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <div className="w-full py-10 flex flex-col items-center justify-center text-center">
                      <p className="font-poppins text-[16px] md:text-[18px] text-[#303030] font-[500]">No Offers Found</p>
                      <p className="font-poppins text-[12px] md:text-[14px] text-[#767676] mt-1">Please create your first offer.</p>
                    </div>
                  </TableCell>
                </TableRow>
              )}
              {visibleOffers?.map((offer, index) => {
                return (
                  <TableRow
                    className="h-[50px]"
                    sx={{
                      boxShadow: "0px 4px 4px 0px #00000040",
                      backgroundColor:
                        (index + 1) % 2 !== 0 ? "#F5F5F5" : "#FFFFFF",
                    }}
                    key={offer._id}
                  >
                    <TableCell className="max-w-[50px]">{(currentPage - 1) * 10 + index + 1}</TableCell>
                    <TableCell
                      title={offer?.title}
                      className="max-w-[100px] truncate"
                    >
                      {offer?.title || "N/A"}
                    </TableCell>
                    <TableCell
                      title={offer?.category?.title}
                      className="max-w-[80px] truncate"
                    >
                      {offer?.category?.title || "N/A"}
                    </TableCell>
                    <TableCell className="max-w-[180px]">
                      {(() => {
                        switch (offer?.offerType) {
                          case "ONLINE_OFFER":
                            return "ONLINE OFFER";
                          case "INSTORE_SWOODLE_OFFER":
                            return "INSTORE SWOODLE OFFER";
                          default:
                            return "N/A";
                        }
                      })()}
                    </TableCell>
                    <TableCell
                      title={offer?.offerDiscountType}
                      className="max-w-[80px] truncate"
                    >
                      {(() => {
                        switch (offer?.offerDiscountType) {
                          case "FREE_OFFER":
                            return "FREE OFFER";
                          case "DISCOUNTED_PERCENT":
                            return "DISCOUNTED PERCENT";
                          case "FIXED_DOLLAR":
                            return "FIXED DOLLAR";
                          case "BUY_ONE_GET_ONE_FREE":
                            return "BUY ONE GET ONE FREE";
                          case "BUNDLE_OFFER":
                            return "BUNDLE OFFER";
                          default:
                            return "N/A";
                        }
                      })()}
                    </TableCell>
                    <TableCell className="max-w-[110px]">
                      <Confirmation
                        status={offer?.status}
                        handleInfoClick={() => handleInfoClick(offer)}
                      />
                    </TableCell>
                    {/* <TableCell>
                      <Status
                        isEnabled={offer?.isEnabled}
                        handleToggle={() => handleToggle(offer?._id)}
                      />
                    </TableCell> */}
                    <TableCell className="max-w-[120px]">
                      <button
                        className="flex justify-center items-center border border-[#00ADEF] rounded-[6px] p-3 h-[34px]"
                        onClick={() =>
                          openPopup(offer?._id)
                        }
                      >
                        <span className="font-[600] text-[14px] text-[#00ADEF] font-poppins leading-[22px]">
                          View Details
                        </span>
                      </button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default MerchantOfferlist;